export default function genererMouvementOd() {
  return {
    dateMouvement: new Date(),
    debit: 0,
    credit: 0,
    libelle: '',
    tiersId: null,
  };
}
